import React from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import './index.css';

export const ServiceDetails = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const image = location.state.image;

  if (!image) {
    return <div>Image not found</div>;
  }

  return (
    <div className="detailed-view">
      <h1>{image.title}</h1>
      <img src={image.src} alt={image.title} className="detailed-image" />
      <p className="description">{image.description}</p>
      <button onClick={() => navigate(-1)}>Back</button>
    </div>
  );
};
